import * as Sentry from '@sentry/browser';
import { Integrations } from '@sentry/tracing';
import env from 'environment';

Sentry.init({
  dsn: env.SENTRY_DSN,
  enviroment: env.SENTRY_ENV,
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 0.5,
});



// WEBPACK FOOTER //
// ./app/utils/sentry.js